var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.href ? 'a' : 'div',{tag:"a",staticClass:"tidal-image-wrapper",class:{
        'block': _vm.block || _vm.aspectRatio,
        'placeholder': _vm.aspectRatio,
        'position-relative': _vm.aspectRatio || _vm.height,
        'transparent': _vm.transparent,
        'fullwidth': _vm.fullwidth,
        'tidal-lazy-image-wrapper': _vm.lazyload,
        'tidal-lazy-image-wrapper--loaded': !_vm.lazyload,
    },style:(_vm.imageStyle),attrs:{"href":_vm.href}},[(_vm.active && _vm.image)?_c('img',{directives:[{name:"scroll",rawName:"v-scroll",value:({ type: 'image', disabled: !_vm.lazyload }),expression:"{ type: 'image', disabled: !lazyload }"}],staticClass:"tidal-image",class:[_vm.imageclass, {
            'block': _vm.block,
            'position-absolute': _vm.aspectRatio,
            'fullwidth': _vm.fullwidth,
            'tidal-lazy-image': _vm.lazyload,
            'img-cover': _vm.crop,
        }],attrs:{"src":_vm.src,"data-src":_vm.lazyload ? _vm.largestSrc : null,"srcset":_vm.lazyload ? null : _vm.imageSources.srcset,"data-srcset":_vm.lazyload ? _vm.imageSources.srcset : null,"sizes":_vm.imageSources.sizes,"alt":_vm.alt}}):_vm._e(),_vm._v(" "),(_vm.noscript)?_c('noscript',{domProps:{"innerHTML":_vm._s(_vm.noscript)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }